export class AttachmentContentNotFoundError extends Error {
    
}